<template>
  <div class="container">
    <Progress :active-index="stepNum" />
    <div class="main">
      <!-- <a-spin :spinning="spinning" /> -->
      <Step3 v-if="step === 2" :insureNotice="insureNotice" />
      <Step2 
        v-if="step === 1" 
        :step="step"
        :needData="needData"
        @StepData2="StepData2"
      />
      <Step1
        ref="step1"
        v-if="step === 0"
        :step="step"
        :data-source="dataSource"
        :spinning="spinning"
        @confirm="confirm"
      />
      <Operate v-if="OperateShow" class="operate" :step="step" :is-next="isNext" />
    </div>
    <div class="notice-dialog">
      <a-modal
        v-model="insureInfoDialog.visible"
        title="资料提交成功"
        centered
        :mask-closable="false"
        :closable="false"
      >
        <div class="operate-success">
          <img
            src="@/assets/image/icon-cg.png"
            alt=""
          >
          <p class="p1">
            提交成功，24小时内业务人员会将审核结果致电步经办人，请注意来电并按照提示完成操作！
          </p>
          <p class="p2">订单状态：
            <span>
              待审核
            </span>
          </p>
        </div>

        <template v-slot:footer>
          <a-button
            @click="insureInfoDialog.visible = false"
            type="primary"
          >
          查看订单 
          </a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { dateFormatDay } from '@/utils/format.js';

import invitationLetterTpl from "@/assets/tpl/invitationLetter.js";
import Progress from "./../../components/nonProgress";
import Operate from "./components/Operate";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";
import {
  information,
  getInformation,
  verify,
  getChannelInfo,
  getList,
  confirmInsure
} from "@/api/nonBidInsure.js";
export default {
  name: "InsurePage",
  components: {
    Progress,
    Operate,
    Step1,
    Step2,
    Step3
  },
  data() {
    return {
      moment,
      locale,
      form: this.$form.createForm(this, { name: "dynamic_rule" }),
      readDocMap: [],
      stepNum: 0,
      spinning: false,
      orderCode: "",
      state: "",
      step: null,
      dataSource: {},
      invitationLetterTpl,
      stepList: ["填写投保信息", "合同签署", "提交投保完成"],
      pickCompanyCode: "",
      insureInfoDialog: {
        visible: false
      },
      isNext: false,
      upLoadList: {},
      insureNotice: "",
      certTypeList: [],
      envUrl: process.env.VUE_APP_DANBAO_HREF,
      timer: 5,
      needData:{},
      backletterFormat:'',
      form2:{},
      OperateShow:false,
    };
  },
  created() {
    this.getInformation();
    // this.init();
    // setInterval(async () => {
    // }, 2000);
  },
  methods: {
    StepData2(val){
      this.form2 = val
    },
    onArree() {
      this.form.validateFields(err => {
        if (!err) {
          this.insureInfoDialog.visible = false;
        }
      });
    },
    compareToFirstChecked(rule, value, callback) {
      if (!value) {
        callback("请勾选协议");
      } else {
        callback();
      }
    },
    // 倒计时
    countDownTimer() {
      if (this.timer > 0) {
        setTimeout(() => {
          this.timer -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getInformation() {
      this.spinning = true;
      this.orderCode = this.getQueryString("orderCode");
      getInformation({ orderCode: this.orderCode }).then(response => {
        this.OperateShow = true
        const res = response.data;
        this.nextStatus(res);
        this.state = res.state;
        this.dataSource = res;
        this.spinning = false;
        // // 显示第几步
        if (res.state === "0") {
          this.step = 0;
          // 回显信息
          this.$nextTick(() => {
            this.$refs.step1.init();
          });
        } else if (res.state === "2") {
          this.step = 2;
        } else {
          this.step = 2;
        }
      });
    },
    // 下一步
    information() {
      let that = this
      console.log(this.dataSource)
      this.orderCode = this.getQueryString("orderCode");
      if (this.step === 0) {
        this.$refs.step1.form.validateFields((err, values) => {
          console.log(values, 999)
          if (!err) {
            this.spinning = false;
            const data = {
              id:this.dataSource.id,
              guaranteeSourceId:this.dataSource.guaranteeSourceId,
              orderCode:this.dataSource.orderCode,
              upstreamCode:this.dataSource.upstreamCode,
              product:this.dataSource.product,
              productName:this.dataSource.productName,
              winTenderTime:this.dataSource.winTenderTime,
              state:this.dataSource.state,
              stateDesc:this.dataSource.stateDesc,
              backletterFormat:this.dataSource.backletterFormat,
              formatPath:this.dataSource.formatPath,
              sectionName:this.dataSource.sectionName,
              sectionCode:this.dataSource.sectionCode,
              projectName:this.dataSource.projectName,
              projectCode:this.dataSource.projectCode,
              // 
              beneficiary: values.beneficiary,
              beneficiaryCreditCode: values.beneficiaryCreditCode,
              beneficiaryPhone: values.beneficiaryPhone,
              beneficiaryRegisteredAddress: values.beneficiaryRegisteredAddress,
              bidPrice: values.bidPrice,
              sumAmount: values.sumAmount,
              guaranteePeriodType: values.guaranteePeriodType,
              guaranteePeriod: values.guaranteePeriod,
              guaranteeEndDate: dateFormatDay(values.guaranteeEndDate),

              
              isSignContract: values.isSignContract,

              durationStartDate: dateFormatDay(values.durationStartDate),
              durationEndDate: dateFormatDay(values.durationEndDate),
              projectNature: values.projectNature,
              maxAptitudeLevel: values.maxAptitudeLevel,
              // 
              enterpriseName: values.enterpriseName,
              creditCode: values.creditCode,
              registeredAddress: values.registeredAddress,
              legalName: values.legalName,
              bidderPhone: values.bidderPhone,
              customerContact: values.customerContact,
              handlePhone: values.handlePhone,
              fileList: this.dataSource.fileList,
              // 
              institutionId: values.institutionId,
              institutionName: values.institutionName,


              // invoiceType: values.invoiceType,
              // invoiceHead: values.invoiceHead,
              // invoiceCuscCode: values.invoiceCuscCode,
              // invoiceEmail: values.invoiceEmail,
              // period: values.period,
              // responsiblePersonName: values.responsiblePersonName,
              // responsiblePersonPhone: values.mobile,
              // code: values.code,
              // phCode: values.phCode,
              // partnerCode: values.partnerCode,
              // addInfo: values.addInfo,
              // bankInfo: values.bankInfo,
              // bankAcc: values.bankAcc,
              // addressee: values.addressee,
              // addresseePhone: values.addresseePhone,
              // address: values.address,
              // basicAccountName: values.basicAccountName,
              // basicAccountNo: values.basicAccountNo,
              // invitationCode:values.invitationCode
            };
            console.log(that.$refs.step1.form.getFieldValue('institutionId'))
            this.isNext = true
            information(data).then(res => {
              this.isNext = false
              if (res.status === 200) {
                this.needData = data
                this.nextStatus();
                this.step = 1;
                // this.timer = 5;
                // this.countDownTimer();
                // this.insureInfoDialog.visible = true;
              } else {
                this.$notification.error({
                  message: res.message
                });
              }
            });
          }
        });
      } else if (this.step === 1) {
        // this.needData
        if(this.form2.backletterFormat == '99'&&!this.form2.formatPath){
          this.$message.warning('请上传自定义格式文件');
          return false
        }
        if(this.form2.uloadList_sght.length<1){
          this.$message.warning('请上传施工合同');
          return 
        }
        if(this.form2.uloadList_zbtzs.length<1){
          this.$message.warning('请上传中标通知书');
          return 

        }
        if(this.form2.uloadList_zbwj.length<1){
          this.$message.warning('请上传招标文件');
          return 
        }
        this.needData.fileList = []
        this.needData.fileList= [...this.form2.uloadList_sght,...this.form2.uloadList_zbtzs,...this.form2.uloadList_zbwj]
        this.needData.backletterFormat = this.form2.backletterFormat
        this.needData.formatPath = this.form2.formatPath
        this.isNext = true
        confirmInsure(this.needData).then(res => {
          this.isNext = false
          if (res.status == 200) {
            this.insureInfoDialog.visible = true
            this.getInformation();
            // this.step = 2;
          }
        });
      }
    },
    confirm(form1) {
      this.$refs.step1.form.validateFields((err, values) => {
        if (!err) {
          console.log(values, this.$refs.step1, form1, "form1");
          // if (!values.checked) {
          //   this.$message.warning('请勾选协议');
          //   return false;
          // }
          this.spinning = true;
          if (form1.partnerCode === "xiaMenBank") {
            this.upLoadList = {
              businessLicenseImage:
                !this.$refs.step1.file1 && values.businessLicenseImage
                  ? values.businessLicenseImage.file.response.data.uri
                  : this.$refs.step1.businessLicenseImage[0].url,
              legalPersonCardImage:
                !this.$refs.step1.file2 && values.legalPersonCardImage
                  ? values.legalPersonCardImage.file.response.data.uri
                  : this.$refs.step1.legalPersonCardImage[0].url,
              biddingDocumentUrl:
                !this.$refs.step1.file3 && values.biddingDocumentUrl
                  ? values.biddingDocumentUrl.file.response.data.uri
                  : this.$refs.step1.biddingDocumentUrl[0]
                  ? this.$refs.step1.biddingDocumentUrl[0].url
                  : ""
              // bidCommitmentUrl: !this.$refs.step1.file4 && values.bidCommitmentUrl ? values.bidCommitmentUrl.file.response.data.uri : this.$refs.step1.bidCommitmentUrl[0].url,
              // separateGuaranteePromiseUrl: !this.$refs.step1.file5 && values.separateGuaranteePromiseUrl ? values.separateGuaranteePromiseUrl.file.response.data.uri : this.$refs.step1.separateGuaranteePromiseUrl[0].url,
            };
          }
          const data = {
            orderCode: this.orderCode,
            responsiblePersonPhone: values.phoneNum,
            partnerCode: form1.partnerCode,
            ...this.upLoadList
          };
          verify(data)
            .then(res => {
              console.log(res);
              if (res.status === 200) {
                this.step = 2;
              } else {
                this.$notification.error({
                  message: res.message
                });
              }
              this.spinning = false;
            })
            .catch(err => {
              this.$refs.step1.hiddenModal();
              this.spinning = false;
              const errorMsg = err.response.data.message;
              this.$notification.error({
                message: errorMsg
              });
            });
        }
      });
    },
    back() {
      this.step -= 1;
      if (this.step === 0) {
        this.orderCode = this.getQueryString("orderCode");
        getInformation({ orderCode: this.orderCode }).then(response => {
          console.log("---", response.data);
          this.dataSource = response.data;
          this.$nextTick(() => {
            this.$refs.step1.init(true);
          });
        });
      }
    },
    closePage() {
      if (
        navigator.userAgent.indexOf("Firefox") !== -1 ||
        navigator.userAgent.indexOf("Chrome") !== -1
      ) {
        window.location.href = "about:blank";
        window.close();
      } else {
        window.opener = null;
        window.open(" ", "_self");
        window.close();
      }
    },
    async nextStatus(result) {
      this.orderCode = this.getQueryString("orderCode");
      if(result){
        this.stepNum =Number(result.state);
        this.insureNotice = result.redTxt;
        this.readDocMap = result.files || [];
        return false
      }
      const { data: data } = await getInformation({ orderCode: this.orderCode });
      this.stepNum =Number(data.state);
      this.insureNotice = data.redTxt;
      this.readDocMap = data.files || [];
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  background-color: #fff;
  min-height: 726px;
  margin-top: 30px;
  position: relative;
  width: 1280px;
}

.main {
  padding: 30px 50px 95px;
}

.pickCompany {
  margin-top: 90px;
}

.operate {
  margin-top: 80px;
}

// .notice-dialog {
::v-deep .ant-modal {
  width: 960px !important;
}

::v-deep .ant-modal-content {
  width: 960px !important;
  height: 680px !important;
  padding: 45px 50px;
  box-sizing: border-box;
}

::v-deep .ant-modal-body {
  padding: 24px 0 !important;
}

::v-deep .ant-modal-header {
  border-bottom: none;
}

::v-deep .ant-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  text-align: center;
}

::v-deep .ant-modal-footer {
  border-top: none;
  display: flex;
  justify-content: center;
}

::v-deep .ant-modal-footer button {
  padding: 12px 26px;
  height: auto;
  font-size: 16px;
  line-height: 1;
  margin-left: 50px;
}

// }
.content {
  height: 392px;
  padding: 30px;
  box-sizing: border-box;
  overflow-y: scroll;
  border: 1px solid #e5e5e5;
}
.operate-success img{
  margin: 60px auto;
  display: block;
}
.operate-success .p1{
  margin: 40px auto;
  display: block;
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #000000;
  line-height: 28px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.operate-success .p2{
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #125AFF;
  line-height: 32px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin:60px auto;
}
.operate-success .p2 span{
  color: #EE9300 ;
}
</style>
